import React, { useEffect, useState } from 'react';

export default function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Only show on mobile
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (!isMobile) return;

    // Only show if not already dismissed
    if (localStorage.getItem('pwa_install_dismissed')) return;

    // Track visit count
    const visits = parseInt(localStorage.getItem('pwa_visit_count') || '0') + 1;
    localStorage.setItem('pwa_visit_count', String(visits));

    const handler = e => {
      e.preventDefault();
      setDeferredPrompt(e);
      if (visits >= 2) setShow(true);
    };

    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      localStorage.setItem('pwa_install_dismissed', '1');
    }
    setShow(false);
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    localStorage.setItem('pwa_install_dismissed', '1');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#1B3A5C',
        color: 'white',
        padding: '14px 16px',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        zIndex: 9999,
        boxShadow: '0 -2px 12px rgba(0,0,0,0.3)',
      }}
    >
      <span style={{ fontSize: '22px' }}>📱</span>
      <p style={{ flex: 1, fontSize: '13px', margin: 0, lineHeight: '1.4' }}>
        Install <strong>Ministry AI Toolkit</strong> on your home screen for quick access
      </p>
      <button
        onClick={handleInstall}
        style={{
          backgroundColor: '#C8921A',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          padding: '8px 14px',
          fontWeight: 'bold',
          fontSize: '13px',
          cursor: 'pointer',
          whiteSpace: 'nowrap',
          flexShrink: 0,
        }}
      >
        Install
      </button>
      <button
        onClick={handleDismiss}
        style={{
          background: 'none',
          border: 'none',
          color: 'rgba(255,255,255,0.7)',
          fontSize: '20px',
          cursor: 'pointer',
          padding: '0 4px',
          lineHeight: 1,
          flexShrink: 0,
        }}
        aria-label="Dismiss"
      >
        ×
      </button>
    </div>
  );
}
